import { useChannel } from '../hooks/useChannel';
import Maintenance from '../pages/Maintenance';

// WHY: Define interface for MaintenanceProtector props
// Checks if maintenance mode is enabled for the channel
// Shows maintenance page when enabled, renders children otherwise
// Applies channel theme to maintenance page
export interface MaintenanceProtectorProps {
  children: React.ReactNode; // App content to show when not in maintenance mode
}

function MaintenanceProtector({ children }: MaintenanceProtectorProps) {
  const { isLoading, error, channel } = useChannel();

  // WHY: Render children if maintenance mode is not enabled
  if (!channel?.maintenance?.enabled) return children;

  // WHY: Extract theme variables for maintenance page
  const {
    theme_action_primary,
    theme_action_secondary,
    theme_assets_recolour,
    theme_background_primary,
    theme_background_secondary,
    theme_background_tertiary,
  } = channel;

  // WHY: Build theme object for maintenance page styling
  // Note: This theme object is defined but not actually used in the Maintenance component
  // Left in place in case Maintenance component needs theming in the future
  const theme = {
    '--theme-action-primary': theme_action_primary,
    '--theme-action-secondary': theme_action_secondary,
    '--theme-assets-recolour': theme_assets_recolour,
    '--theme-background-primary': theme_background_primary,
    '--theme-background-secondary': theme_background_secondary,
    '--theme-background-tertiary': theme_background_tertiary,
  };

  return <Maintenance channel={channel} />;
}

export default MaintenanceProtector;
